export enum UserType {
    SuperAdmin = 'super_admin',
    Admin = 'admin',
    Distributor = 'distributor',
    Retailer = 'retailer',
    Staff = 'staff'
}
